export default function FacebookSvg() {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_232_7245)'>
        <path
          d='M20 0C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4C0 1.79086 1.79086 0 4 0H20Z'
          fill='#1877F2'
        />
        <path
          d='M17.2035 12H13.875V9.74925C13.875 8.79975 14.34 7.875 15.8303 7.875H17.3438V4.9215C17.3438 4.9215 15.9705 4.6875 14.6573 4.6875C11.9168 4.6875 10.125 6.34875 10.125 9.35625V12H7.07703V15.4688H10.125V24H13.875V15.4688H16.6703L17.2035 12Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_232_7245'>
          <rect fill='white' height='24' width='24' />
        </clipPath>
      </defs>
    </svg>
  )
}
